import React, { useState } from 'react';
import useLeadData from '../../../hooks/useLeadData';
import useConfiguratorData from '../../../hooks/useConfiguratorData';


const ModalInactivity = ({onCloseModal}) => {
    const { updateLead } = useLeadData();
    const { getSelectedModel, getSelectedVersion, getSummary } = useConfiguratorData();

    const [needContact, setNeedContact] = useState(true);
    const selectedModel = getSelectedModel();
    const selectedVersion = getSelectedVersion();

    const handleNotContactMeButton = () => {
        updateLead([{
            name: 'quiero-que-me-contacten',
            value: 'No'
        }], () => {
            setNeedContact(false) // exito
        }, () => {
            setNeedContact(false) // error
        });
    };

    const contactMe = () => {
        onCloseModal(true)
    }

    const notContactMe = () => {
        onCloseModal(false)
        handleNotContactMeButton();
    }

    return (
        <div className="modal-box">
            {/* <div className="close-button icon close" id="close-modal" onClick={onCloseModal}></div> */}
            <div className="modal-body">
                <h3>¿Sigues ahí?</h3>
                <p>No te pierdas la oportunidad de cotizar tu vehiculo {selectedModel.name} {selectedVersion.name}</p>
                <div className="buttons-container">
                    <a className="btn black modal-continuar-cotizacion" onClick={() => contactMe()}>Quiero que me contacten</a>
                    <a className="btn outline-black modal-sin-contacto" onClick={() => notContactMe()}>No quiero que me contacten</a>
                </div>
            </div>
        </div>
    )
}

export default ModalInactivity;